import { validateMessage } from '@/lib/validation';
import * as util from '@/lib/util';

const normal = [
  { to: 0.1, color: '#171afb' },
  { to: 0.2, color: '#1d8bfa' },
  { to: 0.5, color: '#14c7f4' },
  { to: 1.0, color: '#17e991' },
  { to: 1.9, color: '#1ac618' },
  { to: 3.8, color: '#addb1c' },
  { to: 9.5, color: '#fbff19' },
  { to: 19.0, color: '#ffae22' },
  { color: '#ff1910' },
];

const error = [
  { to: 10, color: '#171afb' },
  { to: 20, color: '#1d8bfa' },
  { to: 30, color: '#14c7f4' },
  { to: 40, color: '#17e991' },
  { to: 50, color: '#1ac618' },
  { to: 60, color: '#addb1c' },
  { to: 70, color: '#fbff19' },
  { to: 80, color: '#ffae22' },
  { color: '#ff1910' },
];

const defaultRangeData = {
  normal,
  error,
};

localStorage.setItem('meshDataRangeDefaultObj', JSON.stringify(defaultRangeData));

export default {
  data() {
    const validateMeshRate = (rule, value, callback) => {
      rule.field.match(/.+\.(\d)\..+/);
      const index = RegExp.$1 * 1;
      if (value === '') {
        alert(validateMessage.required);
      } else if (this.$_meshDataMixin_validationMeshRateValue(value * 1, index)) {
        alert(validateMessage.colorRange);
      } else {
        callback();
      }
    };
    return {
      meshDataMixin: {
        /**
         * @param {object} - validation rules
         */
        rules: {
          rate: [{ validator: validateMeshRate, trigger: 'blur' }],
        },
        // 通常
        normal,
        // 誤差
        error,
      },
    };
  },
  methods: {
    /**
     * 線量値に応じて設定した範囲内のカラーコードを返す
     * @param {number} der - 線量値
     * @returns {string} - Color Hex
     */
    $_meshDataMixin_getMeshColorByDer(der) {
      /**
       * 初期データ or 一つ前の値
       * @returns {number}
       */
      let prevData = 0;
      /**
       * 戻り値
       * @returns {string}
       */
      let colorHex = '';
      /**
       * mesh data 配列
       * @returns {array}
       */
      let meshData = this.$_meshDataMixin_getMeshData;
      meshData.forEach((obj) => {
        if (der > prevData && der <= obj.to) {
          colorHex = obj.color;
        }
        prevData = obj.to;
      });
      // 数値範囲外の場合は最後のカラーに設定
      if (!colorHex) {
        colorHex = meshData[meshData.length - 1].color;
        return colorHex;
      } else {
        return colorHex;
      }
    },
    /**
     * 入力データが正しい範囲内かチェック
     * @param {number} rate - 線量値
     * @param {number} index - 設定データのindex
     * @returns {boolean} true 範囲外 false 範囲内
     */
    $_meshDataMixin_validationMeshRateValue(rate, index) {
      let meshData = this.$_meshDataMixin_getMeshData;
      let flg = false;
      const prevData = index === 0 ? 0 : meshData[index - 1].to;
      // UI都合上の空のデータが最後に入っているので最後から二番目の場合は上限なしとする
      const nextData = index === meshData.length - 2 ? Infinity : meshData[index + 1].to;
      // 値が範囲外ならエラー
      if (!(rate > prevData && rate <= nextData)) {
        flg = true;
      }
      return flg;
    },
    /**
     * 線量範囲がlocalstorageに保存されていた場合は設定する
     */
    $_meshDataMixin_initData() {
      const meshData = this.$localStorage.get('meshDataRangeObj');
      util.forEachValue(meshData, (val, key) => {
        // 空配列以外の場合は値が保存されているので設定
        if (val.length > 0) {
          this.meshDataMixin[key].map((data, index) => {
            data.to = meshData[key][index];
          });
        }
      });
    },
    /**
     * 線量範囲をlocalstorageに保存
     */
    $_meshDataMixin_setData() {
      const meshData = this.$localStorage.get('meshDataRangeObj');
      // 保存されてる値を削除して現在の値で再設定
      meshData[this.$_meshDataMixin_getType] = [];
      this.$_meshDataMixin_getMeshData.forEach((val) => {
        if (val.to) {
          meshData[this.$_meshDataMixin_getType].push(val.to * 1);
        }
      });
      this.$localStorage.set('meshDataRangeObj', meshData);
    },
  },
  computed: {
    /**
     * 現在の表示タイプを返す
     * 0 : 通常メッシュ, 1 : 誤差メッシュ, 2 : 経路表示
     * @returns {string}
     */
    $_meshDataMixin_getType() {
      let type = '';
      switch (this.show) {
        case 0:
          type = 'normal';
          break;
        case 1:
          type = 'error';
          break;
        case 2:
          // 経路表示の場合は通常表示データを表示するため
          type = 'normal';
          break;
      }
      return type;
    },
    /**
     * typeに応じた mesh dataを返す
     * @returns {array}
     */
    $_meshDataMixin_getMeshData() {
      let meshData = [];
      switch (this.$_meshDataMixin_getType) {
        case 'normal':
          meshData = this.meshDataMixin.normal;
          break;
        case 'error':
          meshData = this.meshDataMixin.error;
          break;
      }
      return meshData;
    },
  },
};
